import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '@/context/AuthContext';

export default function ProtectedRoute({ children, roles }) {
  const { user, loading } = useAuth();
  if (loading) return (
    <div className="min-h-screen flex items-center justify-center bg-[#F7F5F4]">
      <div className="text-sm text-slate-500 mono">Securing your session…</div>
    </div>
  );
  if (!user) return <Navigate to="/login" replace />;
  // system_admin is the platform Maker — by design has UNRESTRICTED
  // access to every route. Per v143 "Maker controls all" directive, no
  // role-gated route may ever exclude the Maker. This single check
  // makes that guarantee structural — even if a route's `roles` prop
  // omits `system_admin`, the Maker still passes.
  if (user.role === 'system_admin') return children;
  if (roles && roles.length && !roles.includes(user.role)) {
    return (
      <div className="min-h-screen flex flex-col items-center justify-center bg-[#F7F5F4] gap-3 p-8 text-center">
        <h1 className="display text-3xl">Access restricted</h1>
        <p className="text-slate-600 max-w-md">
          You need one of these roles: <code className="mono">{roles.join(', ')}</code>.
          Your current role is <code className="mono">{user.role}</code>.
        </p>
      </div>
    );
  }
  return children;
}
